import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';
import type { SocialPostRendition } from './social-post-preview-card';
import { postIsFeedShaped, type PostGridCount } from './social-post-look-parts';

export const X_CAPTION_LIMIT = 250;
const X_HANDLE = /^@[A-Za-z0-9_]{1,15}$/;

export type XLook = 'x';

export function xLook(card: Pick<SocialPostPreviewCardMetadata, 'postType'>): XLook | undefined {
  return postIsFeedShaped(card) ? 'x' : undefined;
}

export function xHandle(card: Pick<SocialPostPreviewCardMetadata, 'accountLabel'>): string | undefined {
  const label = card.accountLabel?.trim();
  return label && X_HANDLE.test(label) ? label : undefined;
}

export const X_RENDITIONS: Record<'single' | 'half' | 'quarter', SocialPostRendition> = {
  single: { mode: 'fit', width: 540, height: 1080 },
  half: { mode: 'fill', width: 268, height: 400 },
  quarter: { mode: 'fill', width: 268, height: 198 },
};

export function xGridRendition(count: PostGridCount, index: number): SocialPostRendition {
  return count === 2 || (count === 3 && index === 0) ? X_RENDITIONS.half : X_RENDITIONS.quarter;
}
